import FabricIcon from "components/FabricIcon";
import { useState } from "react";

export function OtherFabricSelector({ fabrics, totalFabricsCount, loadAllFabrics, selectedFabric, setSelectedFabric }) {
    const [showAllFabrics, setShowAllFabrics] = useState(false);

    if (fabrics.length === 0) return null;

    return (
        <>
            <div className="body-text3 gray mb-16 align-center gap_3">
                Select fabric from Wishlist:
            </div>
            <div className="small-images have-first-el-active colors mb-8">
                {fabrics.map(fabric => (
                    <FabricIcon
                        key={fabric.fabricId}
                        fabricId={fabric.fabricId}
                        imageUrl={fabric.imagePath}
                        isActive={fabric.fabricId === selectedFabric}
                        onClick={() => setSelectedFabric(fabric.fabricId)}
                    />
                ))}
            </div>
            {totalFabricsCount > 11 && !showAllFabrics && (
                <div>
                    Show <span style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={async () => {
                            await loadAllFabrics();
                            setShowAllFabrics(true);
                        }}>
                        all {totalFabricsCount} fabrics
                    </span>
                </div>
            )}
            <hr className="secondary-line" />
        </>
    );
}
